export default "__VITE_ASSET__D3VN$QMs__"